export default __webpack_public_path__ + "static/media/us-wi.20bd8e17.svg";